<body>
  <div class="grid-overlay">
    <app-page-header>
      <img src="../../assets/icons/user.png" alt="icono usuario" style="width:50px; height:50px;">
      <h4 class="header-username">{{ username }}</h4>
    </app-page-header>

    <!-- ═══════════════════════════════════════════════════════════════════ -->
    <!-- SISTEMA DE TABS -->
    <!-- ═══════════════════════════════════════════════════════════════════ -->
    <div class="tabs-container">
      <mat-tab-group [selectedIndex]="selectedTabIndex" (selectedIndexChange)="onConfigurationsTabChange($event)" animationDuration="300ms">

        <!-- TAB 1: Provincias y Corregimientos -->
        <mat-tab>
          <ng-template mat-tab-label>
            <mat-icon class="tab-icon">location_on</mat-icon>
            <span class="tab-label">{{ 'configurations.tabs.provinces' | translate }}</span>
          </ng-template>

          <div class="tab-content">
            <form [formGroup]="form">
              <h1>{{ 'configurations.provincesTitle' | translate }}</h1>
              <div class="grid">
                <div class="left">
                  <div class="items">
                    <mat-form-field style="width: 85%;">
                      <mat-label>{{ 'configurations.provinces' | translate }}</mat-label>
                      <mat-select (selectionChange)="onProvinceChange(false)" [formControl]="form.controls['provinces']" multiple>
                        @for (province of provincesList; track province) {
                          <mat-option [value]="province">
                            {{province.name}}
                          </mat-option>
                        }
                      </mat-select>
                    </mat-form-field>
                  </div>
                </div>
                <div class="right">
                  <div class="items">
                    <mat-accordion>
                      @for (province of form.controls['provinces'].value; track province) {
                        <mat-expansion-panel>
                          <mat-expansion-panel-header>
                            <mat-panel-title>
                              {{province.name}}
                            </mat-panel-title>
                            <button mat-icon-button (click)="removeProvince(province)">
                              <mat-icon>close</mat-icon>
                            </button>
                          </mat-expansion-panel-header>
                          <mat-form-field style="width: 85%;">
                            <mat-label>Corregimientos</mat-label>
                            <mat-select (selectionChange)="onCorregimientosChange($event.value, province.id)" [formControl]="form.controls['corregimientos']" multiple>
                              @for (corre of corregimientos[province.id]; track corre) {
                                <mat-option [value]="corre">
                                  {{corre.name}}
                                </mat-option>
                              }
                            </mat-select>
                          </mat-form-field>
                        </mat-expansion-panel>
                      }
                    </mat-accordion>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </mat-tab>

        <!-- TAB 2: Otras Configuraciones -->
        <mat-tab>
          <ng-template mat-tab-label>
            <mat-icon class="tab-icon">settings</mat-icon>
            <span class="tab-label">{{ 'configurations.tabs.otherSettings' | translate }}</span>
          </ng-template>

          <div class="tab-content">
            <h1>{{ 'configurations.otherSettingsTitle' | translate }}</h1>

            <div class="partner-settings-container">
              <mat-slide-toggle
                [(ngModel)]="emailPaymentSucceeded"
                (change)="onToggleChange()"
                >{{ 'configurations.notifyPaymentSuccess' | translate }}</mat-slide-toggle
                >
              </div>

              <br>
                <br>

                  <div>
                    <mat-slide-toggle
                      [(ngModel)]="emailPaymentFailed"
                      (change)="onToggleChange()"
                      >{{ 'configurations.notifyPaymentFailed' | translate }}</mat-slide-toggle
                      >
                    </div>
                    <br>
                      <br>

                        <div>
                          <mat-slide-toggle
                            [(ngModel)]="notifyCancelledSubscription"
                            (change)="onToggleChange()"
                            >{{ 'configurations.notifyCancelledSubscription' | translate }}</mat-slide-toggle
                            >
                          </div>
                          <br>

                          <div class="my-portals-default-tab-setting">
                            <h3>{{ 'configurations.myPortalsDefaultTab.title' | translate }}</h3>
                            <p>{{ 'configurations.myPortalsDefaultTab.description' | translate }}</p>

                            <div class="my-portals-default-tab-setting__options">
                              <label>
                                <input
                                  type="radio"
                                  name="myPortalsDefaultTab"
                                  value="services_first"
                                  [(ngModel)]="myPortalsDefaultTab">
                                <span>{{ 'configurations.myPortalsDefaultTab.servicesFirst' | translate }}</span>
                              </label>
                              <label>
                                <input
                                  type="radio"
                                  name="myPortalsDefaultTab"
                                  value="kpi_first"
                                  [(ngModel)]="myPortalsDefaultTab">
                                <span>{{ 'configurations.myPortalsDefaultTab.kpiFirst' | translate }}</span>
                              </label>
                            </div>
                          </div>
                          <br>

                            <p style="color: red"><strong>{{ 'configurations.warning' | translate }}</strong> {{ 'configurations.costWarning' | translate }}</p>
                          </div>
                        </mat-tab>

                        <!-- TAB 3: Notificaciones para Actualización de Método de Pago -->
                        <mat-tab>
                          <ng-template mat-tab-label>
                            <mat-icon class="tab-icon">notifications</mat-icon>
                            <span class="tab-label">{{ 'configurations.tabs.notifications' | translate }}</span>
                          </ng-template>

                          <div class="tab-content">
                            <h1>{{ 'configurations.notificationsTitle' | translate }}</h1>

                            <div class="partner-settings-container">
                              <mat-slide-toggle
                                [(ngModel)]="emailChangeMethodPayment"
                                (change)="onToggleChange()"
                                >{{ 'configurations.emailChangeMethodPayment' | translate }}</mat-slide-toggle
                                >
                              </div>
                              <br>
                                <p>{{ 'configurations.emailChangeMethodPaymentDescription' | translate }}</p>

                                <br>
                                  <br>

                                    <div>
                                      <mat-slide-toggle
                                        [(ngModel)]="whatsappChangeMethodPayment"
                                        (change)="onToggleChange()"
                                        >{{ 'configurations.whatsappChangeMethodPayment' | translate }}</mat-slide-toggle
                                        >
                                      </div>
                                      <br>
                                        <p>{{ 'configurations.whatsappChangeMethodPaymentDescription' | translate }}</p>
                                        <br>

                                        <p style="color: red"><strong>{{ 'configurations.warning' | translate }}</strong> {{ 'configurations.costWarningNotifications' | translate }}</p>
                                        </div>
                                      </mat-tab>

                                      <!-- TAB 4: SendGrid Templates -->
                                      <mat-tab>
                                        <ng-template mat-tab-label>
                                          <mat-icon class="tab-icon">mail</mat-icon>
                                          <span class="tab-label">{{ 'configurations.tabs.sendgridTemplates' | translate }}</span>
                                        </ng-template>

                                        <div class="tab-content sendgrid-tab">
                                          <div class="sendgrid-heading">
                                            <div>
                                              <h1>
                                                <mat-icon class="section-icon">mail</mat-icon>
                                                {{ 'configurations.sendgrid.title' | translate }}
                                              </h1>
                                              <p class="section-description">{{ 'configurations.sendgrid.description' | translate }}</p>
                                            </div>
                                          </div>

                                          @if (sendgridError) {
                                            <div class="sendgrid-alert">
                                              <mat-icon>warning</mat-icon>
                                              <span>{{ sendgridError }}</span>
                                            </div>
                                          }

                                          @if (sendgridLoading) {
                                            <div class="loading-state">
                                              <mat-spinner diameter="40"></mat-spinner>
                                              <p>{{ 'configurations.sendgrid.loadingConfiguration' | translate }}</p>
                                            </div>
                                          }

                                          @if (!sendgridLoading && sendgridConfiguration) {
                                            <section class="sendgrid-section">
                                              <div class="sendgrid-step-title">
                                                <span>1</span>
                                                <div>
                                                  <h3>{{ 'configurations.sendgrid.senderAccount.title' | translate }}</h3>
                                                  <p>{{ 'configurations.sendgrid.senderAccount.description' | translate }}</p>
                                                </div>
                                              </div>

                                              @if (currentSendgridSender; as sender) {
                                                <div class="sendgrid-sender-summary">
                                                  <div class="sendgrid-sender-avatar">{{ sender.nickname.charAt(0) || sender.fromEmail.charAt(0) }}</div>
                                                  <div class="sendgrid-sender-info">
                                                    <span>{{ 'configurations.sendgrid.senderAccount.current' | translate }}</span>
                                                    <h3>{{ sender.nickname }}</h3>
                                                    <p>{{ sender.fromEmail }}</p>
                                                    @if (sender.replyTo) {
                                                      <small>{{ 'configurations.sendgrid.senderAccount.replyTo' | translate }}: {{ sender.replyTo }}</small>
                                                    }
                                                  </div>
                                                  <div class="sendgrid-sender-actions">
                                                    <span class="sendgrid-sender-badge verified">{{ 'configurations.sendgrid.senderAccount.verified' | translate }}</span>
                                                    <button type="button" class="sendgrid-secondary-btn" (click)="openSenderPicker()">
                                                      <mat-icon>swap_horiz</mat-icon>
                                                      <span>{{ 'configurations.sendgrid.actions.changeSender' | translate }}</span>
                                                    </button>
                                                  </div>
                                                </div>
                                              } @else {
                                                <div class="sendgrid-empty-state">
                                                  <mat-icon>alternate_email</mat-icon>
                                                  <h3>{{ 'configurations.sendgrid.senderAccount.emptyTitle' | translate }}</h3>
                                                  <p>{{ 'configurations.sendgrid.senderAccount.emptyDescription' | translate }}</p>
                                                  <button type="button" class="sendgrid-primary-btn small" (click)="openSenderPicker()">
                                                    <mat-icon>add</mat-icon>
                                                    <span>{{ 'configurations.sendgrid.actions.chooseSender' | translate }}</span>
                                                  </button>
                                                </div>
                                              }
                                            </section>

                                            <section class="sendgrid-section">
                                              <div class="sendgrid-step-title">
                                                <span>2</span>
                                                <div>
                                                  <h3>{{ 'configurations.sendgrid.partnerTemplate.title' | translate }}</h3>
                                                  <p>{{ 'configurations.sendgrid.partnerTemplate.description' | translate }}</p>
                                                </div>
                                              </div>

                                              @if (!hasSendgridTemplate) {
                                                <div class="sendgrid-empty-state">
                                                  <mat-icon>mail_outline</mat-icon>
                                                  <h3>{{ 'configurations.sendgrid.emptyTemplate.title' | translate }}</h3>
                                                  <p>{{ 'configurations.sendgrid.emptyTemplate.description' | translate }}</p>
                                                  <button type="button" class="sendgrid-primary-btn small" (click)="openTemplatePicker()">
                                                    <mat-icon>add</mat-icon>
                                                    <span>{{ 'configurations.sendgrid.actions.chooseTemplate' | translate }}</span>
                                                  </button>
                                                </div>
                                              }

                                              @if (hasSendgridTemplate && currentSendgridTemplate) {
                                                <div class="sendgrid-template-summary">
                                                  <div class="sendgrid-thumb" [class]="'sendgrid-thumb tone-' + currentSendgridTemplate.thumbnailTone">
                                                    @if (currentSendgridTemplate.thumbnailUrl) {
                                                      <img [src]="currentSendgridTemplate.thumbnailUrl" [alt]="currentSendgridTemplate.name">
                                                    } @else {
                                                      <span></span>
                                                    }
                                                  </div>
                                                  <div class="sendgrid-template-info">
                                                    <span>{{ 'configurations.sendgrid.currentTemplate' | translate }}</span>
                                                    <h3>{{ currentSendgridTemplate.name }}</h3>
                                                    <p>{{ 'configurations.sendgrid.templateSummary' | translate: {count: currentSendgridTemplate.versionCount, date: (currentSendgridTemplate.updatedAt | date:'dd/MM/yyyy')} }}</p>
                                                    <code>{{ 'configurations.sendgrid.templateId' | translate }}: {{ currentSendgridTemplate.id }}</code>
                                                  </div>
                                                  <div class="sendgrid-template-actions">
                                                    <button type="button" class="sendgrid-secondary-btn" (click)="openTemplatePicker()">
                                                      <mat-icon>swap_horiz</mat-icon>
                                                      <span>{{ 'configurations.sendgrid.actions.changeTemplate' | translate }}</span>
                                                    </button>
                                                  </div>
                                                </div>
                                              }
                                            </section>

                                            <section class="sendgrid-section">
                                              <div class="sendgrid-step-title">
                                                <span>3</span>
                                                <div>
                                                  <h3>{{ 'configurations.sendgrid.assignVersions.title' | translate }}</h3>
                                                  <p>{{ 'configurations.sendgrid.assignVersions.description' | translate }}</p>
                                                </div>
                                              </div>

                                              <div class="sendgrid-slots-grid">
                                                @for (slot of sendgridSlots; track slot.key) {
                                                  <article class="sendgrid-slot-card" [class.disabled]="!hasSendgridTemplate" [class.orphan]="getSendgridSlotAssignment(slot.key)?.status === 'orphan'">
                                                    <header>
                                                      <div>
                                                        <div class="sendgrid-slot-title">
                                                          <h4>{{ ('configurations.sendgrid.slots.' + slot.key) | translate }}</h4>
                                                          <i class="material-icons sendgrid-slot-help" [matTooltip]="('configurations.sendgrid.helpers.' + slot.key) | translate">help_outline</i>
                                                        </div>
                                                        <code>{{ slot.key }}</code>
                                                      </div>
                                                      <span class="sendgrid-status" [ngClass]="getSendgridSlotStatusClass(slot.key)">
                                                        {{ ('configurations.sendgrid.status.' + getSendgridSlotStatusClass(slot.key)) | translate }}
                                                      </span>
                                                    </header>

                                                    @if (getSendgridSlotVersion(slot.key); as version) {
                                                      <div class="sendgrid-slot-body">
                                                        <div class="sendgrid-thumb small" [class]="'sendgrid-thumb small tone-' + (currentSendgridTemplate?.thumbnailTone || 'navy')">
                                                          @if (version.thumbnailUrl) {
                                                            <img [src]="version.thumbnailUrl" [alt]="version.name">
                                                          } @else {
                                                            <span></span>
                                                          }
                                                        </div>
                                                        <div>
                                                          <h5>
                                                            {{ version.name }}
                                                            @if (version.active) {
                                                              <small>{{ 'configurations.sendgrid.active' | translate }}</small>
                                                            }
                                                          </h5>
                                                          <p>{{ version.subject }}</p>
                                                          <span>{{ version.updatedAt | date:'dd/MM/yyyy' }}</span>
                                                          <code>{{ 'configurations.sendgrid.versionId' | translate }}: {{ version.id }}</code>
                                                          <div class="sendgrid-link-actions">
                                                            <button type="button" class="sendgrid-secondary-btn small" (click)="openPreview(version)">
                                                              <mat-icon>visibility</mat-icon>
                                                              {{ 'configurations.sendgrid.actions.preview' | translate }}
                                                            </button>
                                                            <button type="button" class="sendgrid-primary-btn small" (click)="openVersionPicker(slot)">
                                                              <mat-icon>swap_horiz</mat-icon>
                                                              {{ 'configurations.sendgrid.actions.chooseVersion' | translate }}
                                                            </button>
                                                          </div>
                                                        </div>
                                                      </div>
                                                    } @else {
                                                      <div class="sendgrid-slot-empty">
                                                        <mat-icon>add</mat-icon>
                                                        <p>{{ (hasSendgridTemplate ? 'configurations.sendgrid.emptySlot.noVersion' : 'configurations.sendgrid.emptySlot.chooseTemplateFirst') | translate }}</p>
                                                        <button type="button" class="sendgrid-primary-btn small" (click)="openVersionPicker(slot)" [disabled]="!hasSendgridTemplate">
                                                          {{ 'configurations.sendgrid.actions.chooseVersion' | translate }}
                                                        </button>
                                                      </div>
                                                    }
                                                  </article>
                                                }
                                              </div>
                                            </section>
                                          }
                                        </div>
                                      </mat-tab>

                                      <!-- TAB 4: Gestión de Passkeys -->
                                      @if (webAuthnSupported) {
                                        <mat-tab>
                                          <ng-template mat-tab-label>
                                            <mat-icon class="tab-icon">fingerprint</mat-icon>
                                            <span class="tab-label">{{ 'configurations.tabs.passkeys' | translate }}</span>
                                          </ng-template>
                                          <div class="tab-content">
                                            <h1>
                                              <mat-icon class="section-icon">fingerprint</mat-icon>
                                              {{ 'configurations.passkeys.title' | translate }}
                                            </h1>
                                            <p class="section-description">
                                              {{ 'configurations.passkeys.description' | translate: {biometricMethod: biometricMethodName} }}
                                            </p>
                                            <!-- Estado de carga -->
                                            @if (isLoadingPasskeys) {
                                              <div class="loading-state">
                                                <mat-spinner diameter="40"></mat-spinner>
                                                <p>{{ 'configurations.passkeys.loading' | translate }}</p>
                                              </div>
                                            }
                                            <!-- Mensaje de error -->
                                            @if (passkeyError && !isLoadingPasskeys) {
                                              <div class="error-message">
                                                <mat-icon>error_outline</mat-icon>
                                                <span>{{ passkeyError }}</span>
                                              </div>
                                            }
                                            <!-- Sin passkeys -->
                                            @if (!hasPasskeys && !isLoadingPasskeys && !passkeyError) {
                                              <div class="no-passkeys-state">
                                                <mat-icon class="empty-icon">security</mat-icon>
                                                <h3>{{ 'configurations.passkeys.noPasskeys.title' | translate }}</h3>
                                                <p>{{ 'configurations.passkeys.noPasskeys.description' | translate }}</p>
                                                <button
                                                  class="btn-register-passkey"
                                                  (click)="registerNewPasskey()"
                                                  [disabled]="isRegisteringPasskey">
                                                  <mat-icon>{{ isRegisteringPasskey ? 'hourglass_empty' : 'add' }}</mat-icon>
                                                  @if (!isRegisteringPasskey) {
                                                    <span>{{ 'configurations.passkeys.noPasskeys.registerButton' | translate }}</span>
                                                  }
                                                  @if (isRegisteringPasskey) {
                                                    <span>{{ 'configurations.passkeys.noPasskeys.registering' | translate }}</span>
                                                  }
                                                </button>
                                              </div>
                                            }
                                            <!-- Lista de passkeys -->
                                            @if (hasPasskeys && !isLoadingPasskeys) {
                                              <div class="passkeys-list">
                                                <!-- Indicador de estado -->
                                                <div class="passkey-status-indicator">
                                                  <mat-icon class="status-icon">check_circle</mat-icon>
                                                  <div class="status-content">
                                                    <h4>{{ 'configurations.passkeys.activePasskeys.title' | translate }}</h4>
                                                    <p>{{ 'configurations.passkeys.activePasskeys.description' | translate: {count: passkeys.length, plural: passkeys.length > 1 ? 's' : ''} }}</p>
                                                  </div>
                                                </div>
                                                <!-- Botón para agregar nueva passkey -->
                                                <div class="add-passkey-section">
                                                  <div class="add-passkey-info">
                                                    <h4>{{ 'configurations.passkeys.activePasskeys.addDevice' | translate }}</h4>
                                                    <p class="hint-text">{{ 'configurations.passkeys.activePasskeys.addDeviceHint' | translate }}</p>
                                                  </div>
                                                  <button
                                                    class="btn-add-passkey"
                                                    (click)="registerNewPasskey()"
                                                    [disabled]="isRegisteringPasskey"
                                                    matTooltip="Registra una passkey en este dispositivo para validar tu identidad sin esperar PINs por email"
                                                    matTooltipPosition="above">
                                                    <mat-icon>{{ isRegisteringPasskey ? 'hourglass_empty' : 'add_circle' }}</mat-icon>
                                                    @if (!isRegisteringPasskey) {
                                                      <span>{{ 'configurations.passkeys.activePasskeys.addButton' | translate }}</span>
                                                    }
                                                    @if (isRegisteringPasskey) {
                                                      <span>{{ 'configurations.passkeys.noPasskeys.registering' | translate }}</span>
                                                    }
                                                  </button>
                                                </div>
                                                <!-- Tarjetas de passkeys -->
                                                <div class="passkeys-grid">
                                                  @for (passkey of passkeys; track passkey) {
                                                    <div class="passkey-card">
                                                      <div class="passkey-card-header">
                                                        <mat-icon class="device-icon">{{ getDeviceIcon(passkey.deviceName) }}</mat-icon>
                                                        <div class="passkey-info">
                                                          <h4>{{ passkey.deviceName }}</h4>
                                                          <p class="last-used">{{ getLastUsedText(passkey.lastUsedAt) }}</p>
                                                        </div>
                                                      </div>
                                                      <div class="passkey-card-body">
                                                        <div class="passkey-detail">
                                                          <mat-icon class="detail-icon">calendar_today</mat-icon>
                                                          <div>
                                                            <span class="detail-label">{{ 'configurations.passkeys.card.registered' | translate }}</span>
                                                            <span class="detail-value">{{ passkey.createdAt | date:'dd/MM/yyyy' }}</span>
                                                          </div>
                                                        </div>
                                                        <div class="passkey-detail">
                                                          <mat-icon class="detail-icon">verified_user</mat-icon>
                                                          <div>
                                                            <span class="detail-label">{{ 'configurations.passkeys.card.status' | translate }}</span>
                                                            <span class="detail-value status-active">{{ 'configurations.passkeys.card.active' | translate }}</span>
                                                          </div>
                                                        </div>
                                                      </div>
                                                      <div class="passkey-card-footer">
                                                        <button
                                                          class="btn-delete-passkey"
                                                          (click)="deletePasskey(passkey)"
                                                          [disabled]="isLoadingPasskeys">
                                                          <mat-icon>delete</mat-icon>
                                                          <span>{{ 'configurations.passkeys.card.deleteButton' | translate }}</span>
                                                        </button>
                                                      </div>
                                                    </div>
                                                  }
                                                </div>
                                                <!-- Información adicional -->
                                                <div class="passkey-info-box">
                                                  <mat-icon class="info-icon">info</mat-icon>
                                                  <div class="info-content">
                                                    <h4>{{ 'configurations.passkeys.info.title' | translate }}</h4>
                                                    <p>
                                                      {{ 'configurations.passkeys.info.description' | translate: {biometricMethod: biometricMethodName} }}
                                                    </p>
                                                  </div>
                                                </div>
                                                <!-- Zona de Peligro -->
                                                <div class="danger-zone">
                                                  <h3>
                                                    <mat-icon class="danger-icon">warning</mat-icon>
                                                    {{ 'configurations.passkeys.dangerZone.title' | translate }}
                                                  </h3>
                                                  <div class="danger-content">
                                                    <div class="danger-description">
                                                      <h4>{{ 'configurations.passkeys.dangerZone.deleteAll' | translate }}</h4>
                                                      <p>
                                                        {{ 'configurations.passkeys.dangerZone.deleteAllDescription' | translate }}
                                                      </p>
                                                      <p class="warning-note">
                                                        <mat-icon>info</mat-icon>
                                                        <span>{{ 'configurations.passkeys.dangerZone.warningNote' | translate }}</span>
                                                      </p>
                                                    </div>
                                                    <button
                                                      class="btn-delete-all"
                                                      (click)="deleteAllPasskeys()"
                                                      [disabled]="isLoadingPasskeys">
                                                      <mat-icon>delete_forever</mat-icon>
                                                      <span>{{ 'configurations.passkeys.dangerZone.deleteAllButton' | translate }}</span>
                                                    </button>
                                                  </div>
                                                </div>
                                                <!-- Sección de FAQ -->
                                                <div class="passkey-faq-section">
                                                  <h3>
                                                    <mat-icon class="faq-icon">help_outline</mat-icon>
                                                    {{ 'configurations.passkeys.faq.title' | translate }}
                                                  </h3>
                                                  <mat-accordion>
                                                    <mat-expansion-panel>
                                                      <mat-expansion-panel-header>
                                                        <mat-panel-title>
                                                          <mat-icon class="question-icon">lightbulb</mat-icon>
                                                          {{ 'configurations.passkeys.faq.whatIsPasskey.question' | translate }}
                                                        </mat-panel-title>
                                                      </mat-expansion-panel-header>
                                                      <p>
                                                        {{ 'configurations.passkeys.faq.whatIsPasskey.answer' | translate: {biometricMethod: biometricMethodName} }}
                                                      </p>
                                                    </mat-expansion-panel>
                                                    <mat-expansion-panel>
                                                      <mat-expansion-panel-header>
                                                        <mat-panel-title>
                                                          <mat-icon class="question-icon">security</mat-icon>
                                                          {{ 'configurations.passkeys.faq.isSafe.question' | translate }}
                                                        </mat-panel-title>
                                                      </mat-expansion-panel-header>
                                                      <div class="faq-content">
                                                        <p><strong>{{ 'configurations.passkeys.faq.isSafe.answerIntro' | translate }}</strong></p>
                                                        <ul>
                                                          <li><mat-icon>check</mat-icon> {{ 'configurations.passkeys.faq.isSafe.reason1' | translate }}</li>
                                                          <li><mat-icon>check</mat-icon> {{ 'configurations.passkeys.faq.isSafe.reason2' | translate }}</li>
                                                          <li><mat-icon>check</mat-icon> {{ 'configurations.passkeys.faq.isSafe.reason3' | translate }}</li>
                                                          <li><mat-icon>check</mat-icon> {{ 'configurations.passkeys.faq.isSafe.reason4' | translate }}</li>
                                                        </ul>
                                                      </div>
                                                    </mat-expansion-panel>
                                                    <mat-expansion-panel>
                                                      <mat-expansion-panel-header>
                                                        <mat-panel-title>
                                                          <mat-icon class="question-icon">devices</mat-icon>
                                                          {{ 'configurations.passkeys.faq.multipleDevices.question' | translate }}
                                                        </mat-panel-title>
                                                      </mat-expansion-panel-header>
                                                      <p>
                                                        {{ 'configurations.passkeys.faq.multipleDevices.answer' | translate }}
                                                      </p>
                                                    </mat-expansion-panel>
                                                    <mat-expansion-panel>
                                                      <mat-expansion-panel-header>
                                                        <mat-panel-title>
                                                          <mat-icon class="question-icon">warning</mat-icon>
                                                          {{ 'configurations.passkeys.faq.lostDevice.question' | translate }}
                                                        </mat-panel-title>
                                                      </mat-expansion-panel-header>
                                                      <p>
                                                        {{ 'configurations.passkeys.faq.lostDevice.answer' | translate }}
                                                        <strong>{{ 'configurations.passkeys.faq.lostDevice.important' | translate }}</strong>
                                                      </p>
                                                    </mat-expansion-panel>
                                                    <mat-expansion-panel>
                                                      <mat-expansion-panel-header>
                                                        <mat-panel-title>
                                                          <mat-icon class="question-icon">email</mat-icon>
                                                          {{ 'configurations.passkeys.faq.stillUsePin.question' | translate }}
                                                        </mat-panel-title>
                                                      </mat-expansion-panel-header>
                                                      <p>
                                                        {{ 'configurations.passkeys.faq.stillUsePin.answer' | translate }}
                                                      </p>
                                                    </mat-expansion-panel>
                                                    <mat-expansion-panel>
                                                      <mat-expansion-panel-header>
                                                        <mat-panel-title>
                                                          <mat-icon class="question-icon">speed</mat-icon>
                                                          {{ 'configurations.passkeys.faq.howFast.question' | translate }}
                                                        </mat-panel-title>
                                                      </mat-expansion-panel-header>
                                                      <div class="faq-content">
                                                        <p><strong>{{ 'configurations.passkeys.faq.howFast.answerIntro' | translate }}</strong></p>
                                                        <ul>
                                                          <li><mat-icon>schedule</mat-icon> <strong>{{ 'configurations.passkeys.faq.howFast.withPinLabel' | translate }}</strong> {{ 'configurations.passkeys.faq.howFast.withPinDesc' | translate }}</li>
                                                          <li><mat-icon>bolt</mat-icon> <strong>{{ 'configurations.passkeys.faq.howFast.withPasskeyLabel' | translate }}</strong> {{ 'configurations.passkeys.faq.howFast.withPasskeyDesc' | translate }}</li>
                                                        </ul>
                                                        <p>{{ 'configurations.passkeys.faq.howFast.conclusion' | translate }}</p>
                                                      </div>
                                                    </mat-expansion-panel>
                                                  </mat-accordion>
                                                </div>
                                              </div>
                                            }
                                          </div>
                                        </mat-tab>
                                      }

                                      <!-- TAB 4 alternativo: Mensaje si WebAuthn no está soportado -->
                                      @if (!webAuthnSupported) {
                                        <mat-tab>
                                          <ng-template mat-tab-label>
                                            <mat-icon class="tab-icon">fingerprint</mat-icon>
                                            <span class="tab-label">{{ 'configurations.tabs.passkeys' | translate }}</span>
                                          </ng-template>
                                          <div class="tab-content">
                                            <h1>
                                              <mat-icon class="section-icon">fingerprint</mat-icon>
                                              {{ 'configurations.passkeys.title' | translate }}
                                            </h1>
                                            <div class="not-supported-message">
                                              <mat-icon class="warning-icon">warning</mat-icon>
                                              <h3>{{ 'configurations.passkeys.notSupported.title' | translate }}</h3>
                                              <p>
                                                {{ 'configurations.passkeys.notSupported.description' | translate }}
                                              </p>
                                            </div>
                                          </div>
                                        </mat-tab>
                                      }

                                      <!-- TAB Partners: solo super admin + feature flag -->
                                      @if (isSuperAdmin && createPartnerTabEnabled) {
                                        <mat-tab>
                                          <ng-template mat-tab-label>
                                            <mat-icon class="tab-icon">business</mat-icon>
                                            <span class="tab-label">{{ 'configurations.tabs.partners' | translate }}</span>
                                          </ng-template>

                                          <div class="tab-content">
                                            <app-admin-create-partner></app-admin-create-partner>
                                          </div>
                                        </mat-tab>
                                      }

                                    </mat-tab-group>
                                  </div>

                                  <ng-template #sendgridSenderPickerDialog>
                                    <div class="sendgrid-dialog-header">
                                      <div>
                                        <h2 mat-dialog-title>{{ 'configurations.sendgrid.dialogs.senderPicker.title' | translate }}</h2>
                                        <p>{{ 'configurations.sendgrid.dialogs.senderPicker.description' | translate }}</p>
                                      </div>
                                      <button type="button" mat-icon-button (click)="closeSenderPicker()"><mat-icon>close</mat-icon></button>
                                    </div>
                                    <mat-dialog-content class="sendgrid-dialog-content">
                                      <div class="sendgrid-modal-toolbar">
                                        <mat-form-field appearance="outline">
                                          <mat-label>{{ 'configurations.sendgrid.dialogs.senderPicker.search' | translate }}</mat-label>
                                          <input matInput [(ngModel)]="sendgridSenderSearch" (ngModelChange)="filterSendgridSenders()">
                                        </mat-form-field>
                                        <span>{{ 'configurations.sendgrid.dialogs.senderPicker.senderCount' | translate: {count: filteredSendgridVerifiedSenders.length} }}</span>
                                      </div>
                                      <div class="sendgrid-sender-list">
                                        @for (sender of filteredSendgridVerifiedSenders; track sender.id) {
                                          <button type="button" class="sendgrid-sender-option" [class.selected]="selectedSenderCandidate?.fromEmail === sender.fromEmail" [disabled]="!sender.verified" (click)="selectSenderCandidate(sender)">
                                            <div class="sendgrid-sender-avatar small">{{ sender.nickname.charAt(0) || sender.fromEmail.charAt(0) }}</div>
                                            <div>
                                              <strong>{{ sender.nickname }}</strong>
                                              <p>{{ sender.fromEmail }}</p>
                                              @if (sender.replyTo) {
                                                <span>{{ 'configurations.sendgrid.senderAccount.replyTo' | translate }}: {{ sender.replyTo }}</span>
                                              }
                                            </div>
                                            <span class="sendgrid-sender-badge" [class.verified]="sender.verified" [class.pending]="!sender.verified">
                                              {{ (sender.verified ? 'configurations.sendgrid.senderAccount.verified' : 'configurations.sendgrid.senderAccount.pending') | translate }}
                                            </span>
                                            <mat-icon>{{ selectedSenderCandidate?.fromEmail === sender.fromEmail ? 'radio_button_checked' : 'radio_button_unchecked' }}</mat-icon>
                                          </button>
                                        }
                                      </div>
                                    </mat-dialog-content>
                                    <mat-dialog-actions align="end" class="sendgrid-dialog-actions">
                                      <button type="button" class="sendgrid-secondary-btn" (click)="closeSenderPicker()">{{ 'configurations.sendgrid.actions.cancel' | translate }}</button>
                                      <button type="button" class="sendgrid-primary-btn" (click)="applySelectedSender()" [disabled]="!selectedSenderCandidate">{{ 'configurations.sendgrid.actions.confirm' | translate }}</button>
                                    </mat-dialog-actions>
                                  </ng-template>

                                  <ng-template #sendgridTemplatePickerDialog>
                                    <div class="sendgrid-dialog-header">
                                      <div>
                                        <h2 mat-dialog-title>{{ 'configurations.sendgrid.dialogs.templatePicker.title' | translate }}</h2>
                                        <p>{{ 'configurations.sendgrid.dialogs.templatePicker.description' | translate }}</p>
                                      </div>
                                      <button type="button" mat-icon-button (click)="closeTemplatePicker()"><mat-icon>close</mat-icon></button>
                                    </div>
                                    <mat-dialog-content class="sendgrid-dialog-content">
                                      <div class="sendgrid-modal-toolbar">
                                        <mat-form-field appearance="outline">
                                          <mat-label>{{ 'configurations.sendgrid.dialogs.templatePicker.search' | translate }}</mat-label>
                                          <input matInput [(ngModel)]="sendgridTemplateSearch" (ngModelChange)="filterSendgridTemplates()">
                                        </mat-form-field>
                                        <span>{{ 'configurations.sendgrid.dialogs.templatePicker.templateCount' | translate: {count: filteredSendgridTemplates.length} }}</span>
                                      </div>
                                      <div class="sendgrid-template-grid">
                                        @for (template of filteredSendgridTemplates; track template.id) {
                                          <button type="button" class="sendgrid-template-option" [class.selected]="selectedTemplateCandidate?.id === template.id" (click)="selectTemplateCandidate(template)">
                                            <div class="sendgrid-thumb" [class]="'sendgrid-thumb tone-' + template.thumbnailTone">
                                              @if (template.thumbnailUrl) {
                                                <img [src]="template.thumbnailUrl" [alt]="template.name">
                                              } @else {
                                                <span></span>
                                              }
                                            </div>
                                            <strong>{{ template.name }}</strong>
                                            <span>{{ 'configurations.sendgrid.templateOptionSummary' | translate: {count: template.versionCount, date: (template.updatedAt | date:'dd/MM/yyyy')} }}</span>
                                            <code>{{ template.id }}</code>
                                          </button>
                                        }
                                      </div>
                                    </mat-dialog-content>
                                    <mat-dialog-actions align="end" class="sendgrid-dialog-actions">
                                      <button type="button" class="sendgrid-secondary-btn" (click)="closeTemplatePicker()">{{ 'configurations.sendgrid.actions.cancel' | translate }}</button>
                                      <button type="button" class="sendgrid-primary-btn" (click)="applySelectedTemplate()" [disabled]="!selectedTemplateCandidate">{{ 'configurations.sendgrid.actions.applyTemplate' | translate }}</button>
                                    </mat-dialog-actions>
                                  </ng-template>

                                  <ng-template #sendgridVersionPickerDialog>
                                    <div class="sendgrid-dialog-header">
                                      <div>
                                        <h2 mat-dialog-title>{{ 'configurations.sendgrid.dialogs.versionPicker.title' | translate: {slot: (selectedSlot ? (('configurations.sendgrid.slots.' + selectedSlot.key) | translate) : '')} }}</h2>
                                        <p>{{ 'configurations.sendgrid.dialogs.versionPicker.description' | translate: {template: currentSendgridTemplate?.name} }}</p>
                                      </div>
                                      <button type="button" mat-icon-button (click)="closeVersionPicker()"><mat-icon>close</mat-icon></button>
                                    </div>
                                    <mat-dialog-content class="sendgrid-dialog-content">
                                      @if (sendgridVersionsLoading) {
                                        <div class="loading-state"><mat-spinner diameter="36"></mat-spinner><p>{{ 'configurations.sendgrid.dialogs.versionPicker.loading' | translate }}</p></div>
                                      } @else {
                                        <div class="sendgrid-version-list">
                                          @for (version of sendgridVersions; track version.id) {
                                            <button type="button" class="sendgrid-version-option" [class.selected]="selectedVersionCandidate?.id === version.id" (click)="selectVersionCandidate(version)">
                                              <div class="sendgrid-thumb small" [class]="'sendgrid-thumb small tone-' + (currentSendgridTemplate?.thumbnailTone || 'navy')">
                                                @if (version.thumbnailUrl) {
                                                  <img [src]="version.thumbnailUrl" [alt]="version.name">
                                                } @else {
                                                  <span></span>
                                                }
                                              </div>
                                              <div>
                                                <strong>
                                                  {{ version.name }}
                                                  @if (version.active) {
                                                    <small>{{ 'configurations.sendgrid.active' | translate }}</small>
                                                  }
                                                </strong>
                                                <p>{{ version.subject }}</p>
                                                <span>{{ version.updatedAt | date:'dd/MM/yyyy' }}</span>
                                              </div>
                                              <mat-icon>{{ selectedVersionCandidate?.id === version.id ? 'radio_button_checked' : 'radio_button_unchecked' }}</mat-icon>
                                            </button>
                                          }
                                        </div>
                                      }
                                    </mat-dialog-content>
                                    <mat-dialog-actions align="end" class="sendgrid-dialog-actions">
                                      <button type="button" class="sendgrid-secondary-btn" (click)="closeVersionPicker()">{{ 'configurations.sendgrid.actions.cancel' | translate }}</button>
                                      <button type="button" class="sendgrid-secondary-btn" (click)="openPreview(selectedVersionCandidate)" [disabled]="!selectedVersionCandidate">{{ 'configurations.sendgrid.actions.preview' | translate }}</button>
                                      <button type="button" class="sendgrid-primary-btn" (click)="applySelectedVersion()" [disabled]="!selectedVersionCandidate">{{ 'configurations.sendgrid.actions.confirm' | translate }}</button>
                                    </mat-dialog-actions>
                                  </ng-template>

                                  <ng-template #sendgridChangeTemplateDialog>
                                    <h2 mat-dialog-title>{{ 'configurations.sendgrid.dialogs.changeTemplate.title' | translate }}</h2>
                                    <mat-dialog-content class="sendgrid-confirm-body">
                                      <mat-icon>warning</mat-icon>
                                      <h3>{{ 'configurations.sendgrid.dialogs.changeTemplate.question' | translate }}</h3>
                                      <p>{{ 'configurations.sendgrid.dialogs.changeTemplate.description' | translate: {current: currentSendgridTemplate?.name, selected: selectedTemplateCandidate?.name} }}</p>
                                    </mat-dialog-content>
                                    <mat-dialog-actions align="end" class="sendgrid-dialog-actions">
                                      <button type="button" class="sendgrid-secondary-btn" (click)="cancelTemplateChange()">{{ 'configurations.sendgrid.actions.cancel' | translate }}</button>
                                      <button type="button" class="sendgrid-danger-btn" (click)="confirmTemplateChange()">{{ 'configurations.sendgrid.actions.confirmTemplateChange' | translate }}</button>
                                    </mat-dialog-actions>
                                  </ng-template>

                                  <ng-template #sendgridPreviewDialog>
                                    @if (previewVersion) {
                                      <div class="sendgrid-dialog-header">
                                        <div>
                                          <h2 mat-dialog-title>{{ previewVersion.name }}</h2>
                                          <p>{{ previewVersion.subject }} · {{ previewVersion.updatedAt | date:'dd/MM/yyyy' }}</p>
                                        </div>
                                        <button type="button" mat-icon-button (click)="closePreview()"><mat-icon>close</mat-icon></button>
                                      </div>
                                      <mat-dialog-content class="sendgrid-dialog-content preview">
                                        <iframe [title]="'configurations.sendgrid.previewTitle' | translate" sandbox="allow-same-origin" [srcdoc]="previewHtml"></iframe>
                                      </mat-dialog-content>
                                      <mat-dialog-actions align="end" class="sendgrid-dialog-actions">
                                        <button type="button" class="sendgrid-primary-btn" (click)="closePreview()">{{ 'configurations.sendgrid.actions.close' | translate }}</button>
                                      </mat-dialog-actions>
                                    }
                                  </ng-template>

                                  <!-- Botones de acción (siempre visibles) -->
                                  @if (!isPartnersTabActive) {
                                    <div class="buttons">
                                      <div class="action-buttons">
                                        <button (click)="goBack()">{{ 'configurations.buttons.back' | translate }}</button>
                                        <button class="createservice" (click)="goSettings()">{{ 'configurations.buttons.createAdditionalService' | translate }}</button>
                                      </div>
                                      <div class="action-buttons">
                                        <button (click)="saveActiveConfigurations()" [disabled]="selectedTabIndex === 3 && sendgridSaving">
                                          {{ selectedTabIndex === 3 && sendgridSaving ? 'Guardando...' : ('configurations.buttons.save' | translate) }}
                                        </button>
                                      </div>
                                    </div>
                                  }
                                  <!-- Botones de acción (ocultos en el tab Partners) -->
                                </div>
                              </body>
